import { ReactNode } from 'react';

import { H3 } from '@common/headline';

export const Title = ({ children }: { children: ReactNode }): JSX.Element => (
  <div className="mb-8 text-center text-blue">
    <H3>{children}</H3>
  </div>
);
